import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function atLeastOneDayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const fullDay = control.get('fullDay')?.value;
      const firstHalfDay = control.get('firstHalfDay')?.value;
      const secondHalfDay = control.get('secondHalfDay')?.value;
      const holidayType = control.get('holidayType')?.value;
      return (fullDay || firstHalfDay || secondHalfDay || holidayType) ? null : { atLeastOneDay: true };
    };
  }